import React from 'react'
import { styled } from '@mui/material'

const Paper = styled(({ maxWidth = '550px', ...props }) => <div {...props} />)({
  backgroundColor: 'white',
  maxWidth: '550px',
  margin: '0 auto',
  marginBottom: '40px',

  textAlign: 'center',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',

  boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
  padding: '48px 16px 16px 16px',
})

export default Paper
